import React from 'react'

export default (o) => (
	<div style={{padding: '28px', paddingTop: '56px'}}>
		<h1>
			Ooopsie
		</h1>
		<h2>
			It seems that document has been deleted.
		</h2>
		<p style={{fontSize: '11px'}}>
			Sometimes it means the data is loading, you can try to wait for a while=)
		</p>
		<img src={'/' + process.env.REACT_APP_NAME + "/static/img/r2d2.png"} style={{width: '70%', margin: 'auto', display: 'block'}}/>
	</div>
)



// WEBPACK FOOTER //
// ./src/components/Deleted.js